export default __webpack_public_path__ + "static/ice_machine_b.7fd0af29aa34f62eeba088c2e102666f.svg";